"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostStatus = void 0;
var PostStatus;
(function (PostStatus) {
    PostStatus["DRAFT"] = "draft";
    PostStatus["PENDING_APPROVAL"] = "pending_approval";
    PostStatus["SCHEDULED"] = "scheduled";
    PostStatus["IN_PROGRESS"] = "in-progress";
    PostStatus["PUBLISHED"] = "published";
    PostStatus["FAILED"] = "failed";
})(PostStatus || (exports.PostStatus = PostStatus = {}));
